
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api-services/api-service';

// Thunk for fetching the news list
export const fetchNewsList = createAsyncThunk('news/fetchNewsList', async (adminData) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.fetchNewsList(empId, acessToken);
  return response;
});

// Thunk for updating news status
export const updateNewsStatus = createAsyncThunk('news/updateNewsStatus', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.updateNewsStatus(empId, acessToken, payload);
  return response;
});

// Thunk for creating news
export const createNews = createAsyncThunk('news/createNews', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.createNews(empId, acessToken, payload);
  return response;
});

const newsSlice = createSlice({
  name: 'news',
  initialState: {
    newsCount: 0,
    activeNews: [],
    inactiveNews: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch news list
      .addCase(fetchNewsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNewsList.fulfilled, (state, action) => {
        state.loading = false;
        state.newsCount = action.payload.newsCount;
        state.activeNews = action.payload.activeNews;
        state.inactiveNews = action.payload.newsList;
      })
      .addCase(fetchNewsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Update news status
      .addCase(updateNewsStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateNewsStatus.fulfilled, (state, action) => {
        state.loading = false;
        const updatedNews = action.payload;

        // Filter out the updated news from both lists and move it to the correct list
        if (updatedNews.status === 'active') {
          state.activeNews = [...state.activeNews, updatedNews];
          state.inactiveNews = state.inactiveNews.filter((news) => news.SK !== updatedNews.SK);
        } else {
          state.inactiveNews = [...state.inactiveNews, updatedNews];
          state.activeNews = state.activeNews.filter((news) => news.SK !== updatedNews.SK);
        }
      })
      .addCase(updateNewsStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create news
      .addCase(createNews.pending, (state) => {
        state.loading = true;
      })
      .addCase(createNews.fulfilled, (state, action) => {
        state.loading = false;
        state.activeNews.push(action.payload); // Add newly created news to active list
      })
      .addCase(createNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default newsSlice.reducer;
